import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import Masonry from "@mui/lab/Masonry";
import Container from "@mui/material/Container";
import ProjectCard from "../components/portfolio/ProjectCard";
import ProjectModal from "../components/portfolio/modal/ProjectModal";
import projects from "../content/projects.json";

const Portfolio = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const project = projects.projects.find((p) => p.id === projectId);

  const handleClose = () => navigate("/portfolio");

  return (
    <>
      <Container sx={{ paddingTop: "20px", alignItems: "center" }}>
        <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={3}>
          {projects.projects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              onClick={() => navigate(`/portfolio/${project.id}`)}
            />
          ))}
        </Masonry>
      </Container>

      {project && (
        <ProjectModal open={true} handleClose={handleClose} project={project} />
      )}
    </>
  );
};

export default Portfolio;
